import { faCheck, faChevronDown } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ListboxButton } from "@headlessui/react";
import React, { Fragment } from "react";

type ButtonBrandedProps = {
  texto: string;
  textoSeleccionado?: string;
};

export const ButtonBranded: React.FC<ButtonBrandedProps> = ({
  textoSeleccionado,
  texto,
}) => (
  <Fragment>
    <div className="inline-flex divide-x bg-primary rounded-md shadow-sm">
      {textoSeleccionado && (
        <div className="inline-flex items-center gap-x-1.5 rounded-l-md bg-primary px-3 py-2 text-white shadow-sm">
          <p className="text-sm font-semibold">{textoSeleccionado}</p>
        </div>
      )}

      <ListboxButton className="inline-flex items-center rounded-l-none rounded-r-md bg-primary p-2 focus:outline-none focus:ring-2 focus:bg-primary focus:ring-offset-2 focus:ring-offset-gray-50">
        <span className="sr-only">{texto}</span>
        <FontAwesomeIcon icon={faChevronDown} className="h-5 w-5 text-white" />
      </ListboxButton>
    </div>
  </Fragment>
);
